import { Skeleton, Stack, Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import placeholder from '../../../../assets/images/product_image_placeholder.svg';
import { DeviceType, useBreakpoint } from '../../../../hooks/useBreakpoint';
import {
  StyledImage,
  StyledImageContainer,
} from '../../../orders/components/common/product-grid/common/product/ProductImage/ProductImage.styles';
type RecipeGridRowImageProps =
  | {
      imageUrl?: string;
      onClick?: () => void;
      size?: 'small' | 'medium';
      sx?: SxProps<Theme>;
      imgSx?: SxProps<Theme>;
      loadingPlaceholder?: never;
    }
  | {
      size?: 'small' | 'medium';
      sx?: SxProps<Theme>;
      imgSx?: SxProps<Theme>;
      loadingPlaceholder: true;
    };

export const RecipeGridRowImage = (props: RecipeGridRowImageProps): JSX.Element => {
  const deviceType = useBreakpoint().deviceType;
  const size = props.size ?? deviceType === DeviceType.Desktop ? 'small' : 'medium';

  if (props.loadingPlaceholder) {
    return (
      <Stack>
        <Skeleton variant='rectangular'>
          <StyledImageContainer size={size} sx={props.sx} displayMode='table'>
            <StyledImage size={size} src={placeholder} sx={{ p: 2, ...props.imgSx }} displayMode='table' />
          </StyledImageContainer>
        </Skeleton>
      </Stack>
    );
  }

  return (
    <StyledImageContainer size={size} sx={props.sx} displayMode='table'>
      <StyledImage
        src={props.imageUrl || placeholder}
        tabIndex={props.onClick ? 0 : undefined}
        size={size}
        sx={{
          ...(!props.imageUrl && { p: 2 }),
          ...(!props.onClick && { cursor: 'default' }),
          ...props.imgSx,
        }}
        onClick={() => props.onClick?.()}
        onKeyDown={(event: { key: string }) => {
          if (event.key === 'Enter') {
            props.onClick?.();
          }
        }}
        displayMode='table'
      />
    </StyledImageContainer>
  );
};
